export const CSV_HEADERS = {
	CR_NAME: 'cr name',
	CR_EMAIL: 'cr email',
	LOAD_NUMBER: 'load number',
	ORIGIN_CITY: 'origin city',
	ORIGIN_STATE: 'origin state',
	DESTINATION_CITY: 'destination city',
	DESTINATION_STATE: 'destination state',
	TRAILER_TYPE: 'trailer type',
	PICKUP_DATE: 'pick up date',
	DELIVERY_DATE: 'delivery date',
	RATE: 'rate',
	MC: 'mc',
	DOT: 'dot',
};

export const PROJECT_CSV_HEADERS = {
	ORIGIN_CITY: 'origin_city',
	ORIGIN_STATE: 'origin_state',
	ORIGIN_ZIP: 'origin_zip',
	DESTINATION_CITY: 'destination_city',
	DESTINATION_STATE: 'destination_state',
	DESTINATION_ZIP: 'destination_zip',
	TRAILER_TYPE: 'trailer_type',
	DUE_DATE: 'due_date',
	VALUE: 'value',
	MAX_BUY: 'max_buy',
	CUSTOMER_RATE: 'customer_rate',
	COMMODITY: 'commodity',
	TOTAL_WEIGHT: 'total_weight',
	DURATION: 'duration',
	COUNT: 'count',
	MONDAY: 'monday',
	TUESDAY: 'tuesday',
	WEDNESDAY: 'wednesday',
	THURSDAY: 'thursday',
	FRIDAY: 'friday',
	SATURDAY: 'saturday',
	SUNDAY: 'sunday',
	PACKAGING: 'packaging',
	TRAILER_REQUIREMENTS: 'trailer_requirements',
	SHIPPER_NOTES: 'shipper_notes',
	RECEIVER_NOTES: 'receiver_notes',
	CUSTOMER_NAME: 'customer_name',
	LAST_BID: 'last_bid',
};

export const PRICE_LANE_CSV_HEADERS = {
	ORIGIN_CITY: 'origin_city',
	ORIGIN_STATE: 'origin_state',
	DESTINATION_CITY: 'destination_city',
	DESTINATION_STATE: 'destination_state',
	TRAILER_TYPE: 'trailer_type',
	PICKUP_DATE: 'pickup_date',
	DELIVERY_DATE: 'delivery_date',
};

export const BROKER_CSV_HEADERS = {
	BUSINESS_NAME: 'business_name',
	MC: 'mc',
	DOT: 'dot',
	CONTACT_NAME: 'contact_name',
	PHONE: 'phone',
	EMAIL: 'email',
};
